<!--
 * @Author: WangYuzhou
 * @Date: 2024-06-11 19:51:50
 * @LastEditors: WangYuzhou
 * @LastEditTime: 2024-07-03 20:25:59
 * @Description: TODO
-->
<template>
  <div class="bid-div col">

     <auto-scroll-vue :list="items" :speed="1" :waitTime="0" :singleHeight="170">
               <div
              v-for="(item, index) in items"
              :key="index"
              class="auto-scroll-item"
              :style="{zIndex: item.state == 2 ? 100 : ''}"
            >
              <dv-border-box-8 :dur="item.state == 2 ? 3 : 0">
                <div class="item col" style="">
                  <div class="row jc-sb">
                    <div :class="[`color${item.state}`, item.state == 3 ? 'color4' : '']">{{ item.time }}</div>
                    <div :class="[`color${item.state}`]">【{{ item.status }}】</div>
                  </div>
                   <div class="row jc-sb mt10">
                       <div class="fs20">{{ item.productName || "--" }}</div>
                      <div v-if="item.state == 3">成交价：￥{{ item.finalPrice }}</div>
                    </div>
                    <div class="row jc-sb mt10">
                      <div>{{ item.auctionNum }}吨</div>
                      <div>起拍价：￥{{ item.auctionPrice }}</div>
                    </div>
                  <div class="mt10">{{ item.auctionUnit.substring(0,2)+"***"+item.auctionUnit.substring(item.auctionUnit.length-3) }}</div>
                </div>
              </dv-border-box-8>
            </div>
      </auto-scroll-vue>

    <!-- <div v-if="false" class="auto-scroll-container" ref="scrollContainer">
      <div
        class="auto-scroll-content"
         ref="scrollContent"
        :style="{ transform: `translateY(-${currentScroll}px)` }"
      >
        <div
          v-for="(item, index) in items.filter((item) => item.state != 2)"
          :key="index"
          class="auto-scroll-item"
        >
          <dv-border-box-8 :dur="0">
            <div class="item col" style="">
              <div class="row jc-sb">
                <div :class="[`color${item.state}`,item.state==3?'color4':'']">{{ item.time }}</div>
                <div :class="[`color${item.state}`]">【{{ item.status }}】</div>
              </div>
               <div class="row jc-sb mt10">
                   <div class=" fs20">{{ item.productName || "--" }}</div>
                  <div v-if="item.state == 3">成交价：￥{{ item.finalPrice }}</div>
                </div>
                <div class="row jc-sb mt10">
                  <div>{{ item.auctionNum }}吨</div>
                  <div>起拍价：￥{{ item.auctionPrice }}</div>
                </div>
              <div class="mt10">{{ item.auctionUnit }}</div>
            </div>
          </dv-border-box-8>
        </div>

        <div
          v-for="(item, index) in items.filter((item) => item.state != 2)"
          :key="'clone-' + index"
          class="auto-scroll-item"
        >
          <dv-border-box-8 :dur="0">
            <div class="item col" style="">
              <div class="row jc-sb">
                <div :class="[`color${item.state}` , item.state == 3 ? 'color4' : '']">{{ item.time }}</div>
                <div :class="[`color${item.state}`]">【{{ item.status }}】</div>
              </div>
              <div class="row jc-sb mt10">
                 <div class=" fs20">{{ item.productName || "--" }}</div>
                <div v-if="item.state == 3">成交价：￥{{ item.finalPrice }}</div>
              </div>
              <div class="row jc-sb mt10">
                <div>{{ item.auctionNum }}吨</div>
                <div>起拍价：￥{{ item.auctionPrice }}</div>
              </div>
              <div class="mt10">{{ item.auctionUnit }}</div>
            </div>
          </dv-border-box-8>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import autoScrollVue from './autoScroll.vue'
export default {
  name: 'Bidding',
  components: { autoScrollVue },
  data () {
    return {
      currentScroll: 0,
      intervalId: null
    }
  },
  props: {
    items: {
      type: Array
    },
    scrollSpeed: {
      type: Number,
      default: 1 // 滚动速度，值越大滚动越快
    }
  },
  mounted () {
    const contentHeight = this.$refs.scrollContainer.scrollHeight
    console.info('-------contentHeight---------', this.$refs.scrollContainer.scrollHeight)

    this.intervalId = setInterval(() => {
      this.currentScroll += this.scrollSpeed
      if (this.currentScroll >= contentHeight - 170 * 6) {
        this.currentScroll = 0
      }
    }, 16) // 每16毫秒滚动一次，约60帧每秒
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  }
}
</script>

<style lang="less" scoped>
.bid-div {
    height: calc(100vh - 230px);

  .auto-scroll-container {
    height: 100%;
    overflow: hidden;
    // display: none;
  }

  .item {
    height: 100%;
    padding: 20px;
    font-size: 18px;
    font-weight: bold;
    color: #26defd;
  }

  .color1 {
    color: #f59a23;
  }
  .color2 {
    color: #25e49c;
  }
  .color3 {
    // color: #026e0d;
    color: #555555;
  }
  .color4 {
    color: #026e0d;
  }
}

.auto-scroll-content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 230px);
}

.auto-scroll-item {
  height: 170px;
  margin-bottom: 10px;
  background-color: #091d45;
}
</style>
